import { render, staticRenderFns } from "./UiSpinner.vue?vue&type=template&id=e34a696e&scoped=true&"
import script from "./UiSpinner.vue?vue&type=script&lang=js&"
export * from "./UiSpinner.vue?vue&type=script&lang=js&"
import style0 from "./UiSpinner.vue?vue&type=style&index=0&id=e34a696e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34a696e",
  null
  
)

export default component.exports